<div [formGroup]="parentForm" class="standard-form-field" [class.width-100]="isWidth100">
  <label [ngClass]="getFormControl()?.dirty && !getFormControl()?.valid
    ? 'standard-form-label text-error' : 'standard-form-label'" for="{{inputId}}" [class.width-100]="isWidth100">
    {{label | translate}}@if (required){<span class="">*</span>}
  </label>

  <div class="input-wrap" [class.width-100]="isWidth100">
    <input
      id="{{inputId}}"
      [attr.type]="type || 'text'"
      class="standard-form-input"
      [formControlName]="controlName"
      [attr.maxlength]="maxlength || null"
      [ngClass]="{'crc-input-text-error': getFormControl()?.touched && getFormControl()?.status === 'INVALID','is-disabled': disabled}"
      [required]="required"
      [class.width-100]="isWidth100"
    />
    @if (getFormControl()?.touched && getFormControl()?.status === "INVALID") {
      <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
    }
  </div>
</div>

